import React, { ElementType, MouseEventHandler } from 'react'
import clsx from 'clsx'
import { Link as RouterLink } from 'react-router-dom'
import Link from '@mui/material/Link'
import ButtonBase from '@mui/material/ButtonBase'
import Img from 'components/Img'
import { UserImage } from 'models/ApiModels'
import { getScaledSize } from 'utils/ImageUtils'
import { PublishedStatus } from 'components/DataCard/Components'
import styles from './GridImages.module.scss'

type GridImageProps = {
  containerHeight?: number
  containerWidth?: number
  component?: ElementType
  image?: UserImage
  selected?: boolean
  to?: string
  onClick?: MouseEventHandler
}

const GridImage: React.FC<GridImageProps> = props => {
  const {
    component: Component = 'div',
    containerWidth,
    containerHeight,
    image,
    selected,
    to,
    onClick
  } = props

  const disabled = image?.is_published
  const [widthAdjusted = undefined, heightAdjusted = undefined] = getScaledSize(
    image?.width || 0,
    image?.height || 0,
    containerWidth || 0,
    containerHeight || 0
  )

  const ImageComponent = (
    <Img
      className="pointer-events-none h-full w-full select-none bg-lighter object-scale-down"
      image={image}
    />
  )

  return (
    <Component
      className={clsx(
        disabled ? 'opacity-50' : undefined,
        'flex items-center justify-center',
        selected && styles.ResultImageWrapperSelected
      )}
    >
      {onClick ? (
        <ButtonBase
          disabled={disabled}
          className="bg-lighter"
          onClick={onClick}
          style={{
            width: widthAdjusted,
            height: heightAdjusted
          }}
        >
          {ImageComponent}
        </ButtonBase>
      ) : null}

      {to ? (
        <Link
          component={RouterLink}
          to={to}
          className="flex items-center justify-center bg-lighter"
          style={{
            width: widthAdjusted,
            height: heightAdjusted
          }}
        >
          {ImageComponent}
        </Link>
      ) : null}

      {!onClick && !to ? (
        <Component
          className="bg-lighter"
          style={{
            width: widthAdjusted,
            height: heightAdjusted
          }}
        >
          {ImageComponent}
        </Component>
      ) : null}

      <PublishedStatus userImage={image} />
    </Component>
  )
}

export default GridImage
